import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

const StadiumBackground = ({ image, children, overlayColor }) => {
  const [bgImage, setBgImage] = useState('');

  useEffect(() => {
    const images = [
      './stadiums/Old-Trafford.jpg',
      './stadiums/Old-Trafford.jpg',
      './stadiums/afc-bournemouth-vitality.png',
      './stadiums/amex.jpeg',
      './stadiums/anfield.jpg',
      './stadiums/brentford-community.avif',
      './stadiums/city-ground.jpeg',
      './stadiums/craven-cottage.jpeg',
      './stadiums/emirates.webp',
      './stadiums/etihad.jpg',
      './stadiums/goodison-park.jpeg',
      './stadiums/king-power.webp',
      './stadiums/london-stadium.jpg',
      './stadiums/molineux-stadium.jpg',
      './stadiums/portman-road.png',
      './stadiums/selhurst-park.jpeg',
      './stadiums/st-james-park.webp',
      './stadiums/st-marys-stadium.jpg',
      './stadiums/stamford-bridge.jpg',
      './stadiums/tottenham-hotspur-stadium.jpg',
      './stadiums/villa-park.jpeg',
    ];

    const randomImage = images[Math.floor(Math.random() * images.length)];

    setBgImage(randomImage);
  }, []);
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        zIndex: 1,
        '&::before': overlayColor
          ? {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: overlayColor,
              opacity: 0.5,
              zIndex: -1,
            }
          : null,
      }}
    >
      {children}
    </Box>
  );
};

export default StadiumBackground;
